import { includes, isEmpty } from 'lodash/fp';
import api from '../../../api';
import { withData } from '../../hoc/withData';
import { getCurrentUser } from '../../services/CurrentUser';
import Loader from '../Loader';
import { AdminHelpListResolved, AdminHelpListResolvedProps } from './AdminHelpListResolved';

type OuterProps = {
    adminIds: string[];
    children: AdminHelpListResolvedProps['children'];
};

export default withData<AdminHelpListResolvedProps, OuterProps>({
    resolve: {
        admins: ({ adminIds }) => {
            const nonNullIds = adminIds.filter(e => e);

            return isEmpty(nonNullIds) || includes(getCurrentUser().id, nonNullIds)
                ? Promise.resolve([])
                : api.usersMedium.getByIds(nonNullIds);
        },
    },
    pendingComponent: () => <Loader />,
})(AdminHelpListResolved);
